<!-- ./src/components/Movie.vue -->
<template>
 <div class="container" id="vedio">
   <div class="row justify-content-center">
        <div class="col-md-12">
           <div class="card">
              <div class="card-header text-left">
                <a>
                  <router-link to="/home">
                    <img class="image col-xs-3" id="home" src="@/assets/news/home.png" height="50" width="50" alt="" />
                  </router-link> 
                </a> &nbsp
                 <a>
                  <router-link to="/youtube">
                    <img class="image col-xs-3" id="exit" src="@/assets/exit.png" height="35" width="35" alt="" />
                  </router-link> 
                </a> 
              </div>

              <div class="card-body">
                <div id="weatherApp">
                  <div class="weather-details text-info">
 
<!--Music, Relaxing music-->
                    <b-card no-body class="mb-1" v-if="this.channel=='MUSIC'">
                      <b-card-header header-tag="header" class="p-1" role="tab" @click="selectedVedio('RELAX')">
                        <b-btn block href="#" v-b-toggle.accordionM1 variant="info"><h6 class="text-left">Relaxing Music at {{ setTime() }}&nbsp</h6></b-btn>
                      </b-card-header>
                      <b-collapse id="accordionM1" collapsed accordion="my-accordion" role="tabpanel">
                        <b-card-body>

                            <div class="row" v-for="(data, index) in articles" :key= "data.entry">
                                <div class="col-xs-5 col-sm-5 col-md-5 col-lg-8" align="left">
                                    <p>
                                        <h6> <p>&nbsp{{data['snippet']['title']}}</p></h6>
                                    </p> 
                                </div>
                                <div class="col-xs-7 col-sm-7 col-md-7 col-lg-4" > 
                                        <p><iframe class="margin-left margin-bottom" :src="embedurl + data['snippet']['resourceId']['videoId']"
                                                height="140" width="213" frameborder="5" scrolling="no"
                                                allowfullscreen="allowfullscreen">
                                          </iframe>
                                          <!--<h3>{{link}}{{data['entry']['videoId']}}</h3> --> <!--For Testing-->
                                        </p> 
                                </div>    
                            </div>
 
                          </b-card-body>
                        </b-collapse>
                      </b-card>

<!--Music, Kenny G-->
                    <b-card no-body class="mb-1" v-if="this.channel=='MUSIC'">
                      <b-card-header header-tag="header" class="p-1" role="tab" @click="selectedVedio('KENNYG')">
                        <b-btn block href="#" v-b-toggle.accordionM2 variant="info"><h6 class="text-left">Kenny G at {{ setTime() }}&nbsp</h6></b-btn>
                      </b-card-header>
                      <b-collapse id="accordionM2" collapsed accordion="my-accordion" role="tabpanel">
                        <b-card-body>

                            <div class="row" v-for="(data, index) in articles" :key= "data.entry">
                                <div class="col-xs-5 col-sm-5 col-md-5 col-lg-8" align="left">
                                    <p>
                                        <h6> <p>&nbsp{{data['snippet']['title']}}</p></h6>
                                    </p> 
                                </div>
                                <div class="col-xs-7 col-sm-7 col-md-7 col-lg-4"> 
                                        <p><iframe class="margin-left margin-bottom" :src="embedurl + data['snippet']['resourceId']['videoId']"
                                                height="140" width="213" frameborder="5" scrolling="no"
                                                allowfullscreen="allowfullscreen">
                                          </iframe>
                                          <!--<h3>{{link}}{{data['entry']['videoId']}}</h3> --> <!--For Testing-->
                                        </p> 
                                </div>    
                            </div>
 
                          </b-card-body>
                        </b-collapse>
                      </b-card>

<!--Music, Ghibli-->
                    <b-card no-body class="mb-1" v-if="this.channel=='MUSIC'">
                      <b-card-header header-tag="header" class="p-1" role="tab" @click="selectedVedio('GHIBLI')">
                        <b-btn block href="#" v-b-toggle.accordionM3 variant="info"><h6 class="text-left">宮崎駿 Ghibli at {{ setTime() }}&nbsp</h6></b-btn>
                      </b-card-header>
                      <b-collapse id="accordionM3" collapsed accordion="my-accordion" role="tabpanel">
                        <b-card-body>

                            <div class="row" v-for="(data, index) in articles" :key= "data.entry">
                                <div class="col-xs-5 col-sm-5 col-md-5 col-lg-8" align="left">
                                    <p>
                                        <h6> <p>&nbsp{{data['snippet']['title']}}</p></h6>
                                    </p> 
                                </div>
                                <div class="col-xs-7 col-sm-7 col-md-7 col-lg-4"> 
                                        <p><iframe class="margin-left margin-bottom" :src="embedurl + data['snippet']['resourceId']['videoId']"
                                                height="140" width="213" frameborder="5" scrolling="no"
                                                allowfullscreen="allowfullscreen">
                                          </iframe>
                                          <!--<h3>{{link}}{{data['entry']['videoId']}}</h3> --> <!--For Testing-->
                                        </p> 
                                </div>    
                            </div>
 
                          </b-card-body>
                        </b-collapse>
                      </b-card>

<!--Talkshow, D100-->
                    <b-card no-body class="mb-1" v-if="this.channel=='TALKSHOW'">
                      <b-card-header header-tag="header" class="p-1" role="tab" @click="selectedVedio('D100')">
                        <b-btn block href="#" v-b-toggle.accordion1 variant="info"><h6 class="text-left">D100 at {{ setTime() }}&nbsp</h6></b-btn>
                      </b-card-header>
                      <b-collapse id="accordion1" collapsed accordion="my-accordion" role="tabpanel">
                        <b-card-body>

                            <div class="row" v-for="(data, index) in articles" :key= "data.items">
                                <div class="col-xs-5 col-sm-5 col-md-5 col-lg-8" align="left">
                                    <p>
                                        <h6> <p>&nbsp{{data['snippet']['title']}}</p></h6>
                                    </p> 
                                </div>
                                <div class="col-xs-7 col-sm-7 col-md-7 col-lg-4"> 
                                        <p><iframe class="margin-left margin-bottom" :src="embedurl + data['snippet']['resourceId']['videoId']"
                                                height="140" width="213" frameborder="5" scrolling="no"
                                                allowfullscreen="allowfullscreen">
                                          </iframe>
                                        </p>
                                </div>    
                            </div>
 
                          </b-card-body>
                        </b-collapse>
                      </b-card>

<!--Talkshow, 852-->
                     <b-card no-body class="mb-1" v-if="this.channel=='TALKSHOW'">
                        <b-card-header header-tag="header" class="p-1" role="tab" @click="selectedVedio('852')">
                          <b-btn block href="#" v-b-toggle.accordion2 variant="info"><h6 class="text-left">852 Post at {{ setTime() }}</h6></b-btn>
                        </b-card-header>
                        <b-collapse id="accordion2" collapsed accordion="my-accordion" role="tabpanel" >
                          <b-card-body>

                            <p class="weather-temperature text-center">
                              <!-- Add news here...   -->
                              <div class="row" v-for="(data, index) in articles" :key= "data.entry">
                                  <div class="col-xs-5 col-sm-5 col-md-5 col-lg-8" align="left">
                                    <p>
                                        <h6> <p>&nbsp{{data['snippet']['title']}}</p></h6>
                                    </p> 
                                  </div> 
                                  <div class="col-xs-7 col-sm-7 col-md-7 col-lg-4">
                                    <p><iframe class="margin-left margin-bottom" :src="embedurl + data['snippet']['resourceId']['videoId']"
                                          height="140" width="213" frameborder="5" scrolling="no"
                                          allowfullscreen="allowfullscreen">
                                        </iframe>
                                    </p>
                                  </div>
                              </div>       
                            </p>

                          </b-card-body>
                        </b-collapse>
                     </b-card>
<!--Talkshow, 蕭氏新聞台-->
                    <b-card no-body class="mb-1" v-if="this.channel=='TALKSHOW'">
                      <b-card-header header-tag="header" class="p-1" role="tab" @click="selectedVedio('SIU')">
                        <b-btn block href="#" v-b-toggle.accordion3 variant="info"><h6 class="text-left">蕭氏新聞台 at {{ setTime() }}&nbsp</h6></b-btn>
                      </b-card-header>
                      <b-collapse id="accordion3" collapsed accordion="my-accordion" role="tabpanel">
                        <b-card-body>

                            <div class="row" v-for="(data, index) in articles" :key= "data.items">
                                <div class="col-xs-5 col-sm-5 col-md-5 col-lg-8" align="left">
                                    <p>
                                        <h6> <p>&nbsp{{data['snippet']['title']}}</p></h6>
                                    </p> 
                                </div>
                                <div class="col-xs-7 col-sm-7 col-md-7 col-lg-4"> 
                                        <p><iframe class="margin-left margin-bottom" :src="embedurl + data['snippet']['resourceId']['videoId']"
                                                height="140" width="213" frameborder="5" scrolling="no"
                                                allowfullscreen="allowfullscreen">
                                          </iframe>
                                        </p>
                                </div>    
                            </div>
 
                          </b-card-body>
                        </b-collapse>
                      </b-card>
<!--Talkshow, Tuesday-->
                    <b-card no-body class="mb-1" v-if="this.channel=='TALKSHOW'">
                      <b-card-header header-tag="header" class="p-1" role="tab" @click="selectedVedio('TUE')">
                        <b-btn block href="#" v-b-toggle.accordion4 variant="info"><h6 class="text-left">升旗易得道 at {{ setTime() }}&nbsp</h6></b-btn>
                      </b-card-header>
                      <b-collapse id="accordion4" collapsed accordion="my-accordion" role="tabpanel">
                        <b-card-body>

                            <div class="row" v-for="(data, index) in articles" :key= "data.items">
                                <div class="col-xs-5 col-sm-5 col-md-5 col-lg-8" align="left">
                                    <p>
                                        <h6> <p>&nbsp{{data['snippet']['title']}}</p></h6>
                                    </p> 
                                </div>
                                <div class="col-xs-7 col-sm-7 col-md-7 col-lg-4"> 
                                        <p><iframe class="margin-left margin-bottom" :src="embedurl + data['snippet']['resourceId']['videoId']"
                                                height="140" width="213" frameborder="5" scrolling="no"
                                                allowfullscreen="allowfullscreen">
                                          </iframe>
                                        </p>
                                </div>    
                            </div>
 
                          </b-card-body>
                        </b-collapse>
                      </b-card>
<!--Talkshow, REGAFINANCE-->
                    <b-card no-body class="mb-1" v-if="this.channel=='TALKSHOW'">
                      <b-card-header header-tag="header" class="p-1" role="tab" @click="selectedVedio('REGAFINANCE')">
                        <b-btn block href="#" v-b-toggle.accordion5 variant="info"><h6 class="text-left">一名經人 at {{ setTime() }}&nbsp</h6></b-btn>
                      </b-card-header>
                      <b-collapse id="accordion5" collapsed accordion="my-accordion" role="tabpanel">
                        <b-card-body>

                            <div class="row" v-for="(data, index) in articles" :key= "data.items">
                                <div class="col-xs-5 col-sm-5 col-md-5 col-lg-8" align="left">
                                    <p>
                                        <h6> <p>&nbsp{{data['snippet']['title']}}</p></h6>
                                    </p> 
                                </div>
                                <div class="col-xs-7 col-sm-7 col-md-7 col-lg-4"> 
                                        <p><iframe class="margin-left margin-bottom" :src="embedurl + data['snippet']['resourceId']['videoId']"
                                                height="140" width="213" frameborder="5" scrolling="no"
                                                allowfullscreen="allowfullscreen">
                                          </iframe>
                                        </p>
                                </div>    
                            </div>
 
                          </b-card-body>
                        </b-collapse>
                      </b-card>
<!--Talkshow, REGAFINANCE-->
                    <b-card no-body class="mb-1" v-if="this.channel=='TALKSHOW'">
                      <b-card-header header-tag="header" class="p-1" role="tab" @click="selectedVedio('HONGKONGER')">
                        <b-btn block href="#" v-b-toggle.accordion6 variant="info"><h6 class="text-left">港燦會館 at {{ setTime() }}&nbsp</h6></b-btn>
                      </b-card-header>
                      <b-collapse id="accordion6" collapsed accordion="my-accordion" role="tabpanel">
                        <b-card-body>

                            <div class="row" v-for="(data, index) in articles" :key= "data.items">
                                <div class="col-xs-5 col-sm-5 col-md-5 col-lg-8" align="left">
                                    <p>
                                        <h6> <p>&nbsp{{data['snippet']['title']}}</p></h6>
                                    </p> 
                                </div>
                                <div class="col-xs-7 col-sm-7 col-md-7 col-lg-4"> 
                                        <p><iframe class="margin-left margin-bottom" :src="embedurl + data['snippet']['resourceId']['videoId']"
                                                height="140" width="213" frameborder="5" scrolling="no"
                                                allowfullscreen="allowfullscreen">
                                          </iframe>
                                        </p>
                                </div>    
                            </div>
 
                          </b-card-body>
                        </b-collapse>
                      </b-card>                      
<!--TV, ABC AU-->
                     <b-card no-body class="mb-1" v-if="this.channel=='TV'">
                        <b-card-header header-tag="header" class="p-1" role="tab" @click="selectedVedio('ABCAU')">
                          <b-btn block href="#" v-b-toggle.accordionTV1 variant="info"><h6 class="text-left">ABC Australia at {{ setTime() }}</h6></b-btn>
                        </b-card-header>
                        <b-collapse id="accordionTV1" collapsed accordion="my-accordion" role="tabpanel" >
                          <b-card-body>

                            <p class="weather-temperature text-center">
                              <!-- Add news here...   -->
                              <div class="row" v-for="(data, index) in articles" :key= "data.entry">
                                  <div class="col-xs-5 col-sm-5 col-md-5 col-lg-8" align="left">
                                    <p>
                                        <h6> <p>&nbsp{{data['snippet']['title']}}</p></h6>
                                    </p> 
                                  </div> 
                                  <div class="col-xs-7 col-sm-7 col-md-7 col-lg-4">
                                    <p><iframe class="margin-left margin-bottom" :src="embedurl + data['snippet']['resourceId']['videoId']"
                                          height="140" width="213" frameborder="5" scrolling="no"
                                          allowfullscreen="allowfullscreen">
                                        </iframe>
                                    </p>
                                  </div>
                              </div>       
                            </p>

                          </b-card-body>
                        </b-collapse>
                     </b-card>

<!--TV, Bloomberg-->
                     <b-card no-body class="mb-1" v-if="this.channel=='TV'">
                        <b-card-header header-tag="header" class="p-1" role="tab" @click="selectedVedio('BLOOMBERG')">
                          <b-btn block href="#" v-b-toggle.accordionTV2 variant="info"><h6 class="text-left">Bloomberg at {{ setTime() }}</h6></b-btn>
                        </b-card-header>
                        <b-collapse id="accordionTV2" collapsed accordion="my-accordion" role="tabpanel" >
                          <b-card-body>

                            <p class="weather-temperature text-center">
                              <!-- Add news here...   -->
                              <div class="row" v-for="(data, index) in articles" :key= "data.entry">
                                  <div class="col-xs-5 col-sm-5 col-md-5 col-lg-8" align="left">
                                    <p>
                                        <h6> <p>&nbsp{{data['snippet']['title']}}</p></h6>
                                    </p> 
                                  </div> 
                                  <div class="col-xs-7 col-sm-7 col-md-7 col-lg-4">
                                    <p><iframe class="margin-left margin-bottom" :src="embedurl + data['snippet']['resourceId']['videoId']"
                                          height="140" width="213" frameborder="5" scrolling="no"
                                          allowfullscreen="allowfullscreen">
                                        </iframe>
                                    </p>
                                  </div>
                              </div>       
                            </p>

                          </b-card-body>
                        </b-collapse>
                     </b-card>

<!--TV, RTHK31-->
                     <b-card no-body class="mb-1" v-if="this.channel=='TV'">
                        <b-card-header header-tag="header" class="p-1" role="tab" @click="selectedVedio('RTHK31')">
                          <b-btn block href="#" v-b-toggle.accordionTV3 variant="info"><h6 class="text-left">RTHK 31 at {{ setTime() }}</h6></b-btn>
                        </b-card-header>
                        <b-collapse id="accordionTV3" collapsed accordion="my-accordion" role="tabpanel" >
                          <b-card-body>

                            <p class="weather-temperature text-center">
                              <!-- Add news here...   -->
                              <div class="row" v-for="(data, index) in articles" :key= "data.entry">
                                  <div class="col-xs-5 col-sm-5 col-md-5 col-lg-8" align="left">
                                    <p>
                                        <h6> <p>&nbsp{{data['snippet']['title']}}</p></h6>
                                    </p> 
                                  </div> 
                                  <div class="col-xs-7 col-sm-7 col-md-7 col-lg-4">
                                    <p><iframe class="margin-left margin-bottom" :src="embedurl + data['snippet']['resourceId']['videoId']"
                                          height="140" width="213" frameborder="5" scrolling="no"
                                          allowfullscreen="allowfullscreen">
                                        </iframe>
                                    </p>
                                  </div>
                              </div>       
                            </p>

                          </b-card-body>
                        </b-collapse>
                     </b-card>                     

<!--TV, HK Apple Daily-->
                     <b-card no-body class="mb-1" v-if="this.channel=='TV'">
                        <b-card-header header-tag="header" class="p-1" role="tab" @click="selectedVedio('HKAPPLEDAILY')">
                          <b-btn block href="#" v-b-toggle.accordionTV4 variant="info"><h6 class="text-left">HK Apple Daily at {{ setTime() }}</h6></b-btn>
                        </b-card-header>
                        <b-collapse id="accordionTV4" collapsed accordion="my-accordion" role="tabpanel" >
                          <b-card-body>

                            <p class="weather-temperature text-center">
                              <!-- Add news here...   -->
                              <div class="row" v-for="(data, index) in articles" :key= "data.entry">
                                  <div class="col-xs-5 col-sm-5 col-md-5 col-lg-8" align="left">
                                    <p>
                                        <h6> <p>&nbsp{{data['snippet']['title']}}</p></h6>
                                    </p> 
                                  </div> 
                                  <div class="col-xs-7 col-sm-7 col-md-7 col-lg-4">
                                    <p><iframe class="margin-left margin-bottom" :src="embedurl + data['snippet']['resourceId']['videoId']"
                                          height="140" width="213" frameborder="5" scrolling="no"
                                          allowfullscreen="allowfullscreen">
                                        </iframe>
                                    </p>
                                  </div>
                              </div>       
                            </p>

                          </b-card-body>
                        </b-collapse>
                     </b-card>                     

<!--TV, UFO AREA 51-->
                     <b-card no-body class="mb-1" v-if="this.channel=='TV'">
                        <b-card-header header-tag="header" class="p-1" role="tab" @click="selectedVedio('UFOAREA51')">
                          <b-btn block href="#" v-b-toggle.accordionTV5 variant="info"><h6 class="text-left">UFO by Boyd Bushman at {{ setTime() }}</h6></b-btn>
                        </b-card-header>
                        <b-collapse id="accordionTV5" collapsed accordion="my-accordion" role="tabpanel" >
                          <b-card-body>

                            <p class="weather-temperature text-center">
                              <!-- Add news here...   -->
                              <div class="row" v-for="(data, index) in articles" :key= "data.entry">
                                  <div class="col-xs-5 col-sm-5 col-md-5 col-lg-8" align="left">
                                    <p>
                                        <h6> <p>&nbsp{{data['snippet']['title']}}</p></h6>
                                    </p> 
                                  </div> 
                                  <div class="col-xs-7 col-sm-7 col-md-7 col-lg-4">
                                    <p><iframe class="margin-left margin-bottom" :src="embedurl + data['snippet']['resourceId']['videoId']"
                                          height="140" width="213" frameborder="5" scrolling="no"
                                          allowfullscreen="allowfullscreen">
                                        </iframe>
                                    </p>
                                  </div>
                              </div>       
                            </p>

                          </b-card-body>
                        </b-collapse>
                     </b-card>

<!--ANIMATION, CARTOON NETWORK UK-->
                     <b-card no-body class="mb-1" v-if="this.channel=='ANIMATION'">
                        <b-card-header header-tag="header" class="p-1" role="tab" @click="selectedVedio('CARTOONNETWORKUK')">
                          <b-btn block href="#" v-b-toggle.accordionA1 variant="info"><h6 class="text-left">Cartoon Network UK at {{ setTime() }}</h6></b-btn>
                        </b-card-header>
                        <b-collapse id="accordionA1" collapsed accordion="my-accordion" role="tabpanel" >
                          <b-card-body>

                            <p class="weather-temperature text-center">
                              <!-- Add news here...   -->
                              <div class="row" v-for="(data, index) in articles" :key= "data.entry">
                                  <div class="col-xs-5 col-sm-5 col-md-5 col-lg-8" align="left">
                                    <p>
                                        <h6> <p>&nbsp{{data['snippet']['title']}}</p></h6>
                                    </p> 
                                  </div> 
                                  <div class="col-xs-7 col-sm-7 col-md-7 col-lg-4">
                                    <p><iframe class="margin-left margin-bottom" :src="embedurl + data['snippet']['resourceId']['videoId']"
                                          height="140" width="213" frameborder="5" scrolling="no"
                                          allowfullscreen="allowfullscreen">
                                        </iframe>
                                    </p>
                                  </div>
                              </div>       
                            </p>

                          </b-card-body>
                        </b-collapse>
                     </b-card> 

<!--ANIMATION, Mr Bean-->
                     <b-card no-body class="mb-1" v-if="this.channel=='ANIMATION'">
                        <b-card-header header-tag="header" class="p-1" role="tab" @click="selectedVedio('MRBEAN')">
                          <b-btn block href="#" v-b-toggle.accordionA2 variant="info"><h6 class="text-left">Mr Bean at {{ setTime() }}</h6></b-btn>
                        </b-card-header>
                        <b-collapse id="accordionA2" collapsed accordion="my-accordion" role="tabpanel" >
                          <b-card-body>

                            <p class="weather-temperature text-center">
                              <!-- Add news here...   -->
                              <div class="row" v-for="(data, index) in articles" :key= "data.entry">
                                  <div class="col-xs-5 col-sm-5 col-md-5 col-lg-8" align="left">
                                    <p>
                                        <h6> <p>&nbsp{{data['snippet']['title']}}</p></h6>
                                    </p> 
                                  </div> 
                                  <div class="col-xs-7 col-sm-7 col-md-7 col-lg-4">
                                    <p><iframe class="margin-left margin-bottom" :src="embedurl + data['snippet']['resourceId']['videoId']"
                                          height="140" width="213" frameborder="5" scrolling="no"
                                          allowfullscreen="allowfullscreen">
                                        </iframe>
                                    </p>
                                  </div>
                              </div>       
                            </p>

                          </b-card-body>
                        </b-collapse>
                     </b-card> 

<!--ANIMATION, Crayon Shichan-->
                     <b-card no-body class="mb-1" v-if="this.channel=='ANIMATION'">
                        <b-card-header header-tag="header" class="p-1" role="tab" @click="selectedVedio('CRAYON')">
                          <b-btn block href="#" v-b-toggle.accordionA3 variant="info"><h6 class="text-left">Crayon Shinchan at {{ setTime() }}</h6></b-btn>
                        </b-card-header>
                        <b-collapse id="accordionA3" collapsed accordion="my-accordion" role="tabpanel" >
                          <b-card-body>

                            <p class="weather-temperature text-center">
                              <!-- Add news here...   -->
                              <div class="row" v-for="(data, index) in articles" :key= "data.entry">
                                  <div class="col-xs-5 col-sm-5 col-md-5 col-lg-8" align="left">
                                    <p>
                                        <h6> <p>&nbsp{{data['snippet']['title']}}</p></h6>
                                    </p> 
                                  </div> 
                                  <div class="col-xs-7 col-sm-7 col-md-7 col-lg-4">
                                    <p><iframe class="margin-left margin-bottom" :src="embedurl + data['snippet']['resourceId']['videoId']"
                                          height="140" width="213" frameborder="5" scrolling="no"
                                          allowfullscreen="allowfullscreen">
                                        </iframe>
                                    </p>
                                  </div>
                              </div>       
                            </p>

                          </b-card-body>
                        </b-collapse>
                     </b-card> 

<!--ANIMATION, POKEMON-->
                     <b-card no-body class="mb-1" v-if="this.channel=='ANIMATION'">
                        <b-card-header header-tag="header" class="p-1" role="tab" @click="selectedVedio('POKEMON')">
                          <b-btn block href="#" v-b-toggle.accordionA4 variant="info"><h6 class="text-left">Pokemon at {{ setTime() }}</h6></b-btn>
                        </b-card-header>
                        <b-collapse id="accordionA4" collapsed accordion="my-accordion" role="tabpanel" >
                          <b-card-body>

                            <p class="weather-temperature text-center">
                              <!-- Add news here...   -->
                              <div class="row" v-for="(data, index) in articles" :key= "data.entry">
                                  <div class="col-xs-5 col-sm-5 col-md-5 col-lg-8" align="left">
                                    <p>
                                        <h6> <p>&nbsp{{data['snippet']['title']}}</p></h6>
                                    </p> 
                                  </div> 
                                  <div class="col-xs-7 col-sm-7 col-md-7 col-lg-4">
                                    <p><iframe class="margin-left margin-bottom" :src="embedurl + data['snippet']['resourceId']['videoId']"
                                          height="140" width="213" frameborder="5" scrolling="no"
                                          allowfullscreen="allowfullscreen">
                                        </iframe>
                                    </p>
                                  </div>
                              </div>       
                            </p>

                          </b-card-body>
                        </b-collapse>
                     </b-card> 

<!--ANIMATION, Doraemon-->
                     <b-card no-body class="mb-1" v-if="this.channel=='ANIMATION'">
                        <b-card-header header-tag="header" class="p-1" role="tab" @click="selectedVedio('DORAEMON')">
                          <b-btn block href="#" v-b-toggle.accordionA5 variant="info"><h6 class="text-left">Doraemon at {{ setTime() }}</h6></b-btn>
                        </b-card-header>
                        <b-collapse id="accordionA5" collapsed accordion="my-accordion" role="tabpanel" >
                          <b-card-body>

                            <p class="weather-temperature text-center">
                              <!-- Add news here...   -->
                              <div class="row" v-for="(data, index) in articles" :key= "data.entry">
                                  <div class="col-xs-5 col-sm-5 col-md-5 col-lg-8" align="left">
                                    <p>
                                        <h6> <p>&nbsp{{data['snippet']['title']}}</p></h6>
                                    </p> 
                                  </div> 
                                  <div class="col-xs-7 col-sm-7 col-md-7 col-lg-4">
                                    <p><iframe class="margin-left margin-bottom" :src="embedurl + data['snippet']['resourceId']['videoId']"
                                          height="140" width="213" frameborder="5" scrolling="no"
                                          allowfullscreen="allowfullscreen">
                                        </iframe>
                                    </p>
                                  </div>
                              </div>       
                            </p>

                          </b-card-body>
                        </b-collapse>
                     </b-card> 



                  </div>
                </div>
              </div>

               <div class="card-footer text-center">
                <small>Welcome to WeWaMart.</small>
              </div> 
                    
                 
          </div>
        </div>
      </div>
  </div>
  <!-- /container --> 

</template>

<script>

//For retrieve data from Firestore
import firebase from 'firebase'
import {db} from '../main'

export default {
  name: 'vedio', // component name
  props: ['channel'],
  data() {
    return {
      source:'',
      articles: [],
      link:'https://www.youtube.com/embed/',
      result:'',
      playlists:'', //06-Jan-2019
      embedurl:'https://www.youtube.com/embed/',
      playlisturl:'https://www.googleapis.com/youtube/v3/playlistItems?part=snippet&maxResults=50&playlistId='
    }
  },
  methods: {
	  setTime: function() {
      var timeAtLoad = (new Date());/*this.time;*/
      return timeAtLoad.toLocaleTimeString([], {timeZone: 'Australia/Sydney', hour: '2-digit', minute:'2-digit', hour12: true})
		},
    setReplace: function(a,b){  //For replace [feed] from retrieved data.
        var yql = a;
        var feed = b;
        yql = yql.replace("'${feed}'",feed);
        this.result = yql;
    },
    preparePlaylists: function(a){ //6-Jan-2019
      //alert('a: ' + a)
      switch(a){
        case 'KENNYG':
            this.playlists = 'https://www.googleapis.com/youtube/v3/playlistItems?part=snippet&maxResults=5&playlistId=' + 'UU2OcG7ukBiYMe1CdlfFJgNg' + '&key=AIzaSyCqiN5ALnjWnmV3GAxMFBPNLM2umVWsiNk'
            break;
        case 'GHIBLI':
            this.playlists = 'https://www.googleapis.com/youtube/v3/playlistItems?part=snippet&maxResults=5&playlistId=' + 'UUoNRHiZtPEH7-iEYIbxQzrg' + '&key=AIzaSyCqiN5ALnjWnmV3GAxMFBPNLM2umVWsiNk'
            break;
        case 'D100':
            this.playlists = 'https://www.googleapis.com/youtube/v3/playlistItems?part=snippet&maxResults=5&playlistId=' + 'UUbmZSNWyEoM2xtWhbHRPo3w' + '&key=AIzaSyCqiN5ALnjWnmV3GAxMFBPNLM2umVWsiNk'
             break;
        case '852':
            this.playlists = 'https://www.googleapis.com/youtube/v3/playlistItems?part=snippet&maxResults=5&playlistId=' + 'UUSoEEDRY9FZbcdVRB2ZuwGg' + '&key=AIzaSyCqiN5ALnjWnmV3GAxMFBPNLM2umVWsiNk'
            break;
         case 'SIU':
            this.playlists = 'https://www.googleapis.com/youtube/v3/playlistItems?part=snippet&maxResults=5&playlistId=' + 'PLPY0_ooDN1duTFPpAa0O7a8NK1sidhSKp' + '&key=AIzaSyCqiN5ALnjWnmV3GAxMFBPNLM2umVWsiNk'
            break; 
         case 'TUE':
            this.playlists = 'https://www.googleapis.com/youtube/v3/playlistItems?part=snippet&maxResults=5&playlistId=' + 'PLATJMw7lTmpC-uyMQuMP-qFEm6VlN1vbY' + '&key=AIzaSyCqiN5ALnjWnmV3GAxMFBPNLM2umVWsiNk'
            break; 
        case 'REGAFINANCE':
            this.playlists = 'https://www.googleapis.com/youtube/v3/playlistItems?part=snippet&maxResults=5&playlistId=' + 'PLBlwm-p_M-QwIodCWaEA3N9Dmpwi2OfNt' + '&key=AIzaSyCqiN5ALnjWnmV3GAxMFBPNLM2umVWsiNk'
            break;    
        case 'HONGKONGER':
            this.playlists = 'https://www.googleapis.com/youtube/v3/playlistItems?part=snippet&maxResults=5&playlistId=' + 'UUwWgaLuFZBRB-dQQP7pxnbA' + '&key=AIzaSyCqiN5ALnjWnmV3GAxMFBPNLM2umVWsiNk'
            break;                            
        case 'ABCAU':
            this.playlists = 'https://www.googleapis.com/youtube/v3/playlistItems?part=snippet&maxResults=5&playlistId=' + 'UUVgO39Bk5sMo66-6o6Spn6Q' + '&key=AIzaSyCqiN5ALnjWnmV3GAxMFBPNLM2umVWsiNk'
            break;
        case 'BLOOMBERG':
            this.playlists = 'https://www.googleapis.com/youtube/v3/playlistItems?part=snippet&maxResults=5&playlistId=' + 'UUUMZ7gohGI9HcU9VNsr2FJQ' + '&key=AIzaSyCqiN5ALnjWnmV3GAxMFBPNLM2umVWsiNk'
            break;
        case 'RTHK31':
            this.playlists = 'https://www.googleapis.com/youtube/v3/playlistItems?part=snippet&maxResults=5&playlistId=' + 'UU6of7UYhctnYmqABjUqzuxw' + '&key=AIzaSyCqiN5ALnjWnmV3GAxMFBPNLM2umVWsiNk'
            break;
        case 'HKAPPLEDAILY':
            this.playlists = 'https://www.googleapis.com/youtube/v3/playlistItems?part=snippet&maxResults=5&playlistId=' + 'UU1CVr0M-s0Ci7PVQzTGFYqA' + '&key=AIzaSyCqiN5ALnjWnmV3GAxMFBPNLM2umVWsiNk'
            break;
        case 'UFOAREA51':
            this.playlists = 'https://www.googleapis.com/youtube/v3/playlistItems?part=snippet&maxResults=5&playlistId=' + 'UUVmlEoDSeImXV5aPz8EvP0A' + '&key=AIzaSyCqiN5ALnjWnmV3GAxMFBPNLM2umVWsiNk'
            break; 
        case 'CARTOONNETWORKUK':
            this.playlists = 'https://www.googleapis.com/youtube/v3/playlistItems?part=snippet&maxResults=5&playlistId=' + 'UUGydrkfIhUDNCotYQI8TJhA' + '&key=AIzaSyCqiN5ALnjWnmV3GAxMFBPNLM2umVWsiNk'
            break;
        case 'MRBEAN':
            this.playlists = 'https://www.googleapis.com/youtube/v3/playlistItems?part=snippet&maxResults=5&playlistId=' + 'UUWE_ywN-0aeFdGVpLQ6mIwg' + '&key=AIzaSyCqiN5ALnjWnmV3GAxMFBPNLM2umVWsiNk'
            break;
        case 'CRAYON':
            this.playlists = 'https://www.googleapis.com/youtube/v3/playlistItems?part=snippet&maxResults=5&playlistId=' + 'UUJsVYcVsmCjSxKS758LpbBw' + '&key=AIzaSyCqiN5ALnjWnmV3GAxMFBPNLM2umVWsiNk'
        case 'POKEMON':
            this.playlists = 'https://www.googleapis.com/youtube/v3/playlistItems?part=snippet&maxResults=5&playlistId=' + 'UU8h9kGSiaTMQF8IKCkuFMFA' + '&key=AIzaSyCqiN5ALnjWnmV3GAxMFBPNLM2umVWsiNk'
            break;
        case 'DORAEMON':
            this.playlists = 'https://www.googleapis.com/youtube/v3/playlistItems?part=snippet&maxResults=5&playlistId=' + 'UUe0lPrnc_tXmgF51rPIT3rw' + '&key=AIzaSyCqiN5ALnjWnmV3GAxMFBPNLM2umVWsiNk'
            break; 
        case 'RELAX':
            this.playlists = 'https://www.googleapis.com/youtube/v3/playlistItems?part=snippet&maxResults=5&playlistId=' + 'UUb_kshGodseYhLPcDtxWv5w' + '&key=AIzaSyCqiN5ALnjWnmV3GAxMFBPNLM2umVWsiNk'
            break;
        default:
            this.playlists = 'https://www.googleapis.com/youtube/v3/playlistItems?part=snippet&maxResults=5&playlistId=' + 'UUbmZSNWyEoM2xtWhbHRPo3w' + '&key=AIzaSyCqiN5ALnjWnmV3GAxMFBPNLM2umVWsiNk'
      }
      //alert('Playlists: ' + this.playlists)
              
    },
    getCompleteYql: function(a){ //Connect to Firestore and get the data
          var dbRef = db.collection("channels");
          var dbQuery = dbRef.where('channel', '==', a);
          var dbPromise = dbQuery.get();
          var results = [];
          return dbPromise.then(function(querySnapshot) {
          querySnapshot.forEach(doc => {
              results.push(doc.data());
              //alert('Doc is:' + doc.data().yql);
          });
          return Promise.all(results);
        })
        .catch(function(error) {
            console.log("Error getting documents: ", error);
        });
     },
     getYql: function(a){ //Another function to connect Firestore without using Promises.
         db.collection("channels").where('channel','==', a).get().then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            this.setReplace(doc.data().yql, doc.data().feed);
            this.goto = this.result;
            //alert(this.goto);
          })
        })
      },
    selectedVedio: function(a) {
      var goto;
      this.articles = ''; //reset the articles itmes to empty for not to show last selected articles.
      this.$store.commit('change', a);   //update state store
           
      //Following logic is to wait until asyc call is completed, otherwise [goto] will be empty. 
      this.getCompleteYql(a)
      .then(results => {  
        this.preparePlaylists(a);
        this.$http.get(this.playlists).then(function(response){
          return JSON.parse(response.bodyText);
        })
        .then(function(response){
          //alert(response.query.results.feed); 
          this.articles=response.items;
        })
        .catch(function(err){
          alert('playlists error');
          //console.log(playlists err);
        })

      })
      //End


    /*  This is commented due to call Firebase async call to find the feed. If not, [goto] is empty.        
      if (this.$store.getters.channel=='D100'){   //get state from VUEX store
        //this.channel='D100'; //Keep the channel name for showing requested channel items.
        goto = "https://query.yahooapis.com/v1/public/yql?q=select%20entry%20from%20xml%20where%20url%20%3D%20%27https://www.youtube.com/feeds/videos.xml?channel_id=UCbmZSNWyEoM2xtWhbHRPo3w%27%20&format=json&env=store%3A%2F%2Fdatatables.org%2Falltableswithkeys";

        }
      else if (this.$store.getters.channel=='852') {
        //this.channel='852';
        goto = "https://query.yahooapis.com/v1/public/yql?q=select%20entry%20from%20xml%20where%20url%20%3D%20'https://www.youtube.com/feeds/videos.xml?channel_id=UCSoEEDRY9FZbcdVRB2ZuwGg'%20&format=json&env=store%3A%2F%2Fdatatables.org%2Falltableswithkeys";
      }
      else if (this.$store.getters.channel=='ABCAU') {
        goto = "https://query.yahooapis.com/v1/public/yql?q=select%20entry%20from%20xml%20where%20url%20%3D%20'https://www.youtube.com/feeds/videos.xml?channel_id=UCVgO39Bk5sMo66-6o6Spn6Q'%20&format=json&env=store%3A%2F%2Fdatatables.org%2Falltableswithkeys";
      } 
      else if (this.$store.getters.channel=='BLOOMBERG') {
        goto = "https://query.yahooapis.com/v1/public/yql?q=select%20entry%20from%20xml%20where%20url%20%3D%20'https://www.youtube.com/feeds/videos.xml?channel_id=UCUMZ7gohGI9HcU9VNsr2FJQ'%20&format=json&env=store%3A%2F%2Fdatatables.org%2Falltableswithkeys";
      }          
      else if (this.$store.getters.channel=='RTHK31') {
        goto = "https://query.yahooapis.com/v1/public/yql?q=select%20entry%20from%20xml%20where%20url%20%3D%20'https://www.youtube.com/feeds/videos.xml?channel_id=UC6of7UYhctnYmqABjUqzuxw'%20&format=json&env=store%3A%2F%2Fdatatables.org%2Falltableswithkeys";
      }  
      else if (this.$store.getters.channel=='HKAPPLEDAILY') {
        goto = "https://query.yahooapis.com/v1/public/yql?q=select%20entry%20from%20xml%20where%20url%20%3D%20'https://www.youtube.com/feeds/videos.xml?channel_id=UC1CVr0M-s0Ci7PVQzTGFYqA'%20&format=json&env=store%3A%2F%2Fdatatables.org%2Falltableswithkeys";
      }        
     else if (this.$store.getters.channel=='CARTOONNETWORKUK') {
        goto = "https://query.yahooapis.com/v1/public/yql?q=select%20entry%20from%20xml%20where%20url%20%3D%20'https://www.youtube.com/feeds/videos.xml?channel_id=UCGydrkfIhUDNCotYQI8TJhA'%20&format=json&env=store%3A%2F%2Fdatatables.org%2Falltableswithkeys";
      }  
    else if (this.$store.getters.channel=='RELAX') {
        goto = "https://query.yahooapis.com/v1/public/yql?q=select%20entry%20from%20xml%20where%20url%20%3D%20'https://www.youtube.com/feeds/videos.xml?channel_id=UCb_kshGodseYhLPcDtxWv5w'%20&format=json&env=store%3A%2F%2Fdatatables.org%2Falltableswithkeys";
      }  
    else if (this.$store.getters.channel=='KENNYG') {
        goto = "https://query.yahooapis.com/v1/public/yql?q=select%20entry%20from%20xml%20where%20url%20%3D%20'https://www.youtube.com/feeds/videos.xml?channel_id=UC2OcG7ukBiYMe1CdlfFJgNg'%20&format=json&env=store%3A%2F%2Fdatatables.org%2Falltableswithkeys";
      }  
    else if (this.$store.getters.channel=='Ghibli') {
        goto = "https://query.yahooapis.com/v1/public/yql?q=select%20entry%20from%20xml%20where%20url%20%3D%20'https://www.youtube.com/feeds/videos.xml?channel_id=UCoNRHiZtPEH7-iEYIbxQzrg'%20&format=json&env=store%3A%2F%2Fdatatables.org%2Falltableswithkeys";
      }
    else if (this.$store.getters.channel=='MRBEAN') {
        goto = "https://query.yahooapis.com/v1/public/yql?q=select%20entry%20from%20xml%20where%20url%20%3D%20'https://www.youtube.com/feeds/videos.xml?channel_id=UCWE_ywN-0aeFdGVpLQ6mIwg'%20&format=json&env=store%3A%2F%2Fdatatables.org%2Falltableswithkeys";
      }
    else if (this.$store.getters.channel=='CRAYON') {
        goto = "https://query.yahooapis.com/v1/public/yql?q=select%20entry%20from%20xml%20where%20url%20%3D%20'https://www.youtube.com/feeds/videos.xml?channel_id=UCJsVYcVsmCjSxKS758LpbBw'%20&format=json&env=store%3A%2F%2Fdatatables.org%2Falltableswithkeys";
      }
    else if (this.$store.getters.channel=='POKEMON') {
        goto = "https://query.yahooapis.com/v1/public/yql?q=select%20entry%20from%20xml%20where%20url%20%3D%20'https://www.youtube.com/feeds/videos.xml?channel_id=UC8h9kGSiaTMQF8IKCkuFMFA'%20&format=json&env=store%3A%2F%2Fdatatables.org%2Falltableswithkeys";
      }
   else if (this.$store.getters.channel=='DORAEMON') {
        goto = "https://query.yahooapis.com/v1/public/yql?q=select%20entry%20from%20xml%20where%20url%20%3D%20'https://www.youtube.com/feeds/videos.xml?channel_id=UCe0lPrnc_tXmgF51rPIT3rw'%20&format=json&env=store%3A%2F%2Fdatatables.org%2Falltableswithkeys";
      }



      this.$http.get(goto).then(function(response){
        return JSON.parse(response.bodyText);
      })
      .then(function(response){
        //alert(response.query.results.feed);
        this.articles=response.query.results.feed;
      })
      .catch(function(err){
        alert('error');
        console.log(err);
      })
  */

      //this.$forceUpdate();  //Force to re-render again

    }
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#movie {
  margin: 30px 0;
}
.loader {
  text-align: center;
}
.margin-left{
    margin-left: 30px;
}
.margin-top{
    margin-top: 3px;
}
.margin-bottom{
    margin-bottom: 10px;
}

   body {
      padding: 2rem 0;
    }

    h1 {
      font-size: 2rem;
    }

    h2 {
      font-size: 1rem;
    }

    .temp-format {
      float: right;
      margin-bottom: 2rem;
      
      button {
        width: auto;
      }
    }

    .weather-details {
      clear: both;
    }

    .weather-temperature {
      font-size: 3rem;
    }

    .icon {
      font-size: 3rem;  
      margin-bottom: 1rem;
    }

</style>




// WEBPACK FOOTER //
// src/components/vedio.vue